import { Checkbox as e, FieldLabel as t, FieldWrapper as n, FlexBox as r, InputColorPicker as i, InputDatePicker as a, InputDateRangePicker as o, InputDuration as s, InputSelectionList as c, InputText as l, Radio as u, Slider as d, Switch as f, Textarea as p } from "@dixa/lib-shared-habla";
import m from "lodash/pick";
import { useController as h } from "react-hook-form";
import { jsx as g, jsxs as _ } from "react/jsx-runtime";
import v from "moment-timezone";
import y from "lodash/omit";
import b from "lodash/identity";
import { useEffect as x, useState as S } from "react";
// src/utils/getIsHookFormOptionRequired/getIsHookFormOptionRequired.ts
function C(e) {
	return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
// \0callable-external:lodash/pick
var w = m, T = [
	"control",
	"defaultValue",
	"name",
	"rules",
	"shouldUnregister"
];
// src/utils/useHookForm/useHookForm.ts
function E(e) {
	let t = w(e, T);
	return {
		controller: h(t),
		controllerProps: t
	};
}
// src/utils/useHookFormFieldWrapper/utils/hookFormFieldWrapperProps.ts
var D = [
	"className",
	"description",
	"disabled",
	"helpIcon",
	"label",
	"noAlert",
	"noLabel",
	"style"
];
// src/utils/useHookFormFieldWrapper/useHookFormFieldWrapper.ts
function O(e) {
	let { controller: t, controllerProps: n } = E(e);
	return {
		controller: t,
		controllerProps: n,
		fieldWrapperProps: {
			...w(e, D),
			required: C(n.rules?.required),
			meta: {
				touched: t.fieldState.isTouched,
				error: t.fieldState.error?.message,
				success: e.meta?.success,
				warning: e.meta?.warning
			},
			labelFor: n.name,
			noLabel: e.noLabel,
			noAlert: e.noAlert
		}
	};
}
// src/components/hookFormCheckbox/hookFormCheckbox.tsx
var k = (n) => {
	let { controller: { field: i }, controllerProps: { name: a } } = E(n);
	return /* @__PURE__ */ _(r, {
		gap: "200",
		alignItems: "center",
		className: n.className,
		children: [/* @__PURE__ */ g(e, {
			...i,
			id: a,
			checked: i.value,
			disabled: n.componentProps?.disabled,
			onChange: (e) => {
				n.componentProps?.onChange?.(e), i.onChange(e);
			}
		}), n.label && /* @__PURE__ */ g(t, {
			htmlFor: a,
			helpIcon: n.helpIcon,
			children: n.label
		})]
	});
}, A = ({ children: e, ...t }) => {
	let { controller: r, controllerProps: a, fieldWrapperProps: o } = O(t);
	return /* @__PURE__ */ g(n, {
		...o,
		children: /* @__PURE__ */ g(i, {
			...t.componentProps,
			...r.field,
			value: r.field.value ?? "",
			onChange: (e) => {
				t.componentProps?.onChange?.(e), r.field.onChange(e);
			},
			name: a.name,
			disabled: o.disabled,
			status: n.getStatus(o.meta),
			children: e
		})
	});
}, j = (e) => {
	let { controller: { field: { onBlur: t, value: r, ...i } }, controllerProps: { name: o }, fieldWrapperProps: s } = O(e), c = r, l = (t) => {
		e.componentProps?.onChange?.(t), i.onChange?.({
			date: t.date?.toISOString() ?? "",
			localDate: t.localDate?.toISOString() ?? "",
			timezone: t?.timezone ?? "",
			localTimezone: t?.localTimezone ?? ""
		});
	};
	return /* @__PURE__ */ g(n, {
		...s,
		children: /* @__PURE__ */ g(a, {
			...e.componentProps,
			...i,
			name: o,
			onChange: l,
			value: v(c?.localDate, v.ISO_8601).isValid() ? v(c.localDate, v.ISO_8601) : null,
			timezone: c?.timezone,
			"aria-disabled": s.disabled,
			disabled: s.disabled,
			"aria-required": s.required,
			required: s.required,
			dropdownProps: {
				...e.componentProps?.dropdownProps ?? {},
				onClose: t
			},
			status: n.getStatus(s.meta)
		})
	});
}, M = (e) => {
	let { controller: { field: { onBlur: t, value: r, ...i } }, controllerProps: { name: a }, fieldWrapperProps: s } = O(e), c = r, l = (t) => {
		e.componentProps?.onChange?.(t), i.onChange?.({
			startDate: t.startDate?.toISOString() ?? "",
			localStartDate: t.localStartDate?.toISOString() ?? "",
			endDate: t.endDate?.toISOString() ?? "",
			localEndDate: t.localEndDate?.toISOString() ?? "",
			timezone: t?.timezone ?? "",
			localTimezone: t?.localTimezone ?? ""
		});
	};
	return /* @__PURE__ */ g(n, {
		...s,
		children: /* @__PURE__ */ g(o, {
			...e.componentProps,
			...i,
			name: a,
			onChange: l,
			value: {
				startDate: v(c?.localStartDate, v.ISO_8601).isValid() ? v(c.localStartDate, v.ISO_8601) : null,
				endDate: v(c?.localEndDate, v.ISO_8601).isValid() ? v(c.localEndDate, v.ISO_8601) : null
			},
			timezone: c?.timezone,
			"aria-disabled": s.disabled,
			disabled: s.disabled,
			"aria-required": s.required,
			required: s.required,
			dropdownProps: {
				...e.componentProps?.dropdownProps ?? {},
				onClose: t
			}
		})
	});
}, N = (e) => {
	let { controller: t, controllerProps: r, fieldWrapperProps: i } = O(e);
	return /* @__PURE__ */ g(n, {
		...i,
		children: /* @__PURE__ */ g(s, {
			...e.componentProps,
			...t.field,
			value: t.field.value ?? 0,
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(n);
			},
			onBlur: () => {
				e.componentProps?.onBlur?.(), t.field.onBlur();
			},
			name: r.name,
			disabled: i.disabled,
			status: n.getStatus(i.meta)
		})
	});
}, P = y, F = (e) => {
	let { controller: { field: t } } = E(e), n = t.value === e.radioValue;
	return /* @__PURE__ */ g(u, {
		type: "radio",
		...P(t, "value"),
		...e.componentProps || {},
		name: e.name,
		className: e.className,
		checked: n,
		value: e.radioValue
	});
}, I = ({ children: e, ...t }) => {
	let { controller: r, controllerProps: i, fieldWrapperProps: a } = O(t), { name: o, onBlur: s, onChange: l, ...u } = r.field;
	return /* @__PURE__ */ g(n, {
		...a,
		children: /* @__PURE__ */ g(c, {
			...t.componentProps,
			...u,
			onBlur: (e) => {
				t.componentProps?.onBlur?.(e), s();
			},
			onChange: (e) => {
				t.componentProps?.onChange?.(e), l(e.selectedValues);
			},
			id: i.name,
			"aria-disabled": a.disabled,
			disabled: a.disabled,
			"aria-required": a.required,
			required: a.required,
			status: n.getStatus(a.meta),
			children: e
		})
	});
}, L = ({ children: e, ...t }) => {
	let { controller: r, controllerProps: i, fieldWrapperProps: a } = O(t), { name: o, onBlur: s, onChange: l, ...u } = r.field;
	return /* @__PURE__ */ g(n, {
		...a,
		children: /* @__PURE__ */ g(c, {
			...t.componentProps,
			...u,
			multiple: !1,
			value: u.value ? [u.value] : [],
			onBlur: (e) => {
				t.componentProps?.onBlur?.(e), s();
			},
			onChange: (e) => {
				t.componentProps?.onChange?.(e), l(e.selectedValues[0] ?? null);
			},
			id: i.name,
			"aria-disabled": a.disabled,
			disabled: a.disabled,
			"aria-required": a.required,
			required: a.required,
			status: n.getStatus(a.meta),
			children: e
		})
	});
}, R = (e) => {
	let { controller: t, controllerProps: r, fieldWrapperProps: i } = O(e);
	return /* @__PURE__ */ g(n, {
		...i,
		children: /* @__PURE__ */ g(d, {
			...e.componentProps,
			...t.field,
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(n);
			},
			id: r.name,
			"aria-disabled": i.disabled,
			disabled: i.disabled,
			"aria-required": i.required
		})
	});
}, z = b, B = ({ transformValue: e = z, label: n, helpIcon: i, className: a, ...o }) => {
	let { controller: { field: s }, controllerProps: { name: c } } = E(o);
	return /* @__PURE__ */ _(r, {
		gap: "200",
		alignItems: "center",
		className: a,
		children: [/* @__PURE__ */ g(f, {
			...s,
			id: c,
			checked: e(s.value),
			disabled: o.componentProps?.disabled,
			onChange: (t) => {
				o.componentProps?.onChange?.(t), s.onChange(e(t.target.checked));
			}
		}), n && /* @__PURE__ */ g(t, {
			htmlFor: c,
			helpIcon: i,
			children: n
		})]
	});
}, V = (e) => {
	let { controller: t, controllerProps: r, fieldWrapperProps: i } = O(e);
	return /* @__PURE__ */ g(n, {
		...i,
		children: /* @__PURE__ */ g(l, {
			...e.componentProps,
			...t.field,
			value: e.componentProps?.type === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(e.componentProps?.type === "number" ? n.target.valueAsNumber : n);
			},
			id: r.name,
			"aria-disabled": i.disabled,
			disabled: i.disabled,
			"aria-required": i.required,
			required: i.required,
			status: n.getStatus(i.meta)
		})
	});
}, H = (e) => {
	let { controller: t, controllerProps: r, fieldWrapperProps: i } = O(e), { showCharacterLimit: a, ...o } = e.componentProps ?? {}, [s, c] = S(0);
	return x(() => {
		a && t.field.value && t.field.value.length && c(t.field.value.length);
	}, []), /* @__PURE__ */ g(n, {
		...i,
		description: a ? `${a - s} characters left` : i.description,
		children: /* @__PURE__ */ g(p, {
			...o,
			...t.field,
			id: r.name,
			"aria-disabled": i.disabled,
			disabled: i.disabled,
			"aria-required": i.required,
			required: i.required,
			onChange: (e) => {
				a && c(e.target.value.length), t.field.onChange(e.target.value);
			},
			status: n.getStatus(i.meta)
		})
	});
};
export { k as HookFormCheckbox, A as HookFormColorPicker, j as HookFormDatePicker, M as HookFormDateRangePicker, N as HookFormDuration, F as HookFormRadio, I as HookFormSelectionList, L as HookFormSelectionListSingle, R as HookFormSlider, B as HookFormSwitch, V as HookFormText, H as HookFormTextarea, C as getIsHookFormOptionRequired, D as hookFormFieldWrapperProps, E as useHookForm, O as useHookFormFieldWrapper };

//# sourceMappingURL=index.js.map